import React from 'react';
import { Link } from 'react-router-dom';
import { navigation } from '../data/navigation';
import { Logo } from './Logo';
const byAge = ['Babies 0–2', 'Toddlers 2–4', 'Preschool 3–5', 'Little kids 6–9', 'Tweens 10+'];
const byArea = ['Downtown', 'The Mesa', 'Montecito', 'Goleta', 'Carpinteria'];
export function Footer() {
  return <footer className="border-t border-line bg-paper" data-id="element-38" data-mp="36pzb7bq84fiq">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10" data-id="element-39" data-mp="3ufa7afwmplqj">
        <div className="grid gap-x-12 gap-y-14 sm:grid-cols-2 lg:grid-cols-4" data-id="element-40" data-mp="3ucxndx7b91au">
          {navigation.filter(section => section.items).map(section => <nav key={section.label} aria-label={section.label} data-id="element-41" data-mp="3le2icog05x94">
                <h2 className="label mb-5 text-muted" data-id="element-42" data-mp="3qcdsl0a7m9rv">{section.label}</h2>
                <ul className="space-y-3" data-id="element-43" data-mp="29zgj5w4rykk0">
                  <li data-id="element-44" data-mp="29xlymixf0ugg">
                    <Link to={section.href} className="text-[14.5px] text-ink underline decoration-olive underline-offset-4" data-id="element-45" data-mp="2a19vns22jyzx">
                      {section.overviewLabel ?? section.label}
                    </Link>
                  </li>
                  {section.items?.map(item => <li key={item.label} data-id="element-46" data-mp="3v8rhjvky59ya">
                      <Link to={item.href} className="text-[14.5px] text-ink/75 underline-offset-4 transition-colors duration-150 ease-soft hover:text-olive hover:underline" data-id="element-47" data-mp="3v5n74ggw1hz6">
                        {item.label}
                      </Link>
                    </li>)}
                </ul>
              </nav>)}

          <nav aria-label="By age" data-id="element-48" data-mp="huo3izhf4lsg">
            <h2 className="label mb-5 text-muted" data-id="element-49" data-mp="ctgw51j6tomb">By age</h2>
            <ul className="space-y-3" data-id="element-50" data-mp="cw3595lq8c6n">
              {byAge.map(link => <li key={link} data-id="element-51" data-mp="qtrne5oet580">
                  <Link to="/things-to-do" className="text-[14.5px] text-ink/75 underline-offset-4 transition-colors duration-150 ease-soft hover:text-olive hover:underline" data-id="element-52" data-mp="mrwm316haru8">
                    {link}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="By area" data-id="element-53" data-mp="13rpsuop6ah9d">
            <h2 className="label mb-5 text-muted" data-id="element-54" data-mp="18k0qfkwfxqyr">By area</h2>
            <ul className="space-y-3" data-id="element-55" data-mp="18lk6bae6q000">
              {byArea.map(link => <li key={link} data-id="element-56" data-mp="1ckkpwv4hl6o2">
                  <Link to="/things-to-do" className="text-[14.5px] text-ink/75 underline-offset-4 transition-colors duration-150 ease-soft hover:text-olive hover:underline" data-id="element-57" data-mp="1cnozk80q0um4">
                    {link}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-20 flex flex-col gap-8 border-t border-line pt-10 sm:flex-row sm:items-start sm:justify-between" data-id="element-58" data-mp="3oc6oorcz4nwc">
          <div className="flex items-start gap-5" data-id="element-59" data-mp="3tai0h7mtx8h7">
            <span className="text-olive" data-id="element-60" data-mp="2afn7ky1dnbtf">
              <Logo className="h-16 w-16" data-id="element-61" data-mp="2ageu7jczxz7k" />
            </span>
            <p className="max-w-sm text-[13px] leading-[1.8] text-muted" data-id="element-62" data-mp="25o57ec76hf9i">
              Real recommendations from local families who’ve been there too.
              Some links earn a small commission at no cost to you — it keeps
              the events calendar free.
            </p>
          </div>
          <div className="shrink-0 space-y-3 sm:text-right" data-id="element-63" data-mp="2te9dqrbr3t47">
            <p className="label text-muted" data-id="element-64" data-mp="2pcectnxqfhqy">
              © {new Date().getFullYear()} Santa Barbara With Kids
            </p>
            <p data-id="element-65" data-mp="2kcrw34ip3jde">
              <Link to="/site-structure" className="text-[13px] text-ink/70 underline decoration-olive underline-offset-4 hover:text-olive" data-id="element-66" data-mp="2kc8ig002vh56">
                Site plan for this rebuild
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}